// Fonction pour mettre une chaîne entière en majuscules
export const toUpperCase = (string) => {
    return string ? string.toUpperCase() : ''; 
    }